import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../api/axios';
import { deleteHubFromContract, editContract, editHubId } from './clients-slice';
import type { HubsState } from '../../types/store';

const initialState: HubsState = {
  data: [],
  status: 'idle',
  error: null,
};

export const fetchHubs = createAsyncThunk('hubs/fetchHubs', async () => {
  try {
    const response = await axios.get('hubs?limit=1000');
    return response.data;
  } catch (error) {
    console.error('Error fetching hubs:', error);
    throw error;
  }
});

const hubsSlice = createSlice({
  name: 'hubs',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchHubs.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchHubs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchHubs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(deleteHubFromContract.fulfilled, (state, action) => {
        state.data = state.data.filter((hub) => hub.hub_id !== action.payload.hubId);
      })
      .addCase(editContract.fulfilled, (state, action) => {
        const payloadData = action.payload.data;
        if (!payloadData) return;

        const sinceTs = payloadData.since;
        const untilTs = payloadData.until;
        if (!sinceTs && !untilTs) return;

        state.data = state.data.map((hub) => {
          if (hub.contract_id === payloadData.contract_id) {
            const _hub = { ...hub };
            if (sinceTs) {
              _hub.since = sinceTs;
            }
            if (untilTs) {
              _hub.until = untilTs;
            }
            return _hub;
          }
          return hub;
        });
      })
      .addCase(editHubId.fulfilled, (state, action) => {
        const newHubId = action.payload.newHubId;
        const previousHubId = action.payload.previousHubId;
        const index = state.data.findIndex((h) => h.hub_id === previousHubId);
        if (index !== -1 && newHubId) {
          state.data[index] = {
            ...state.data[index],
            hub_id: newHubId,
          };
        }
      });
  },
});

export default hubsSlice.reducer;
